import React from 'react';
import { Container, Row } from 'reactstrap';
import CalendarManagementTable from './components/CalendarManagementTable';
import PageHeader from '../../../shared/components/PageHeader';

const CalendarManagementTablePage = () => (
  <Container>
    <Row>
      <PageHeader title="Calendar Manager" subhead="Calendar Items By End Date Descending" />
    </Row>
    <Row>
      <CalendarManagementTable />
    </Row>
  </Container>
);

export default CalendarManagementTablePage;

